import get from 'lodash/get';
import { Component, EventEmitter, Output } from '@angular/core';
import { CustomComponent } from '@cakeiteasy/web-utils';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CartEventsService, CartState, getCart } from '@cakeiteasy/order-process';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'header-cart',
  templateUrl: './header-cart.component.html',
  styleUrls: ['./header-cart.component.scss']
})
export class HeaderCartComponent extends CustomComponent {
  @Output() public onEditOrdered = new EventEmitter<any>();

  public totalPrice$ = new Observable<number>();
  public cart$: Observable<any>;
  public bakeryCurrency = 'NOK';

  constructor(
    private _cartEvents: CartEventsService,
    private _cartStore: Store<CartState>) {
    super();

    this.cart$ = this._cartStore.select(getCart);
    this.totalPrice$ = this.cart$.pipe(map((cart) => cart && cart.totalPrice));

    this.addSubscriber(this._cartStore.select(getCart)
      .subscribe((cart) => {
        this.bakeryCurrency = get(cart, 'bakery.country.currencySymbol');
      }));
  }

  public showCart() {
    this._cartEvents.showCart();
  }
}
